module.exports = __webpack_public_path__ + "img/christopbanner.8adb7b47.png";